import KidoAPIInstance from "../../services/KidoConfigApi";

export const postFeedBackApi = async data => {
	const path = "api/notification/createCRMFeedback";
	return await KidoAPIInstance.post(path, data);
};
